import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

@observer class HTMLContainer extends Component {

  @observable background = null;

  render() {
    return (
      <div style={{
        background: this.props.background,
        width: '100%',
        height: '100%'
      }}>
        {this.props.children}
      </div>
    );
  }

}

export default HTMLContainer;



// WEBPACK FOOTER //
// ./src/components/document/HTMLContainer.js